import {SearchModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class MeasureSearchModel extends SearchModel<any> {

    constructor(injector: Injector) {
        super(injector);
    }

    override getIdentifierField(): string {
        return "measureId";
    }

    override isEntityLocalisable(): boolean {
        return false;
    }
}
